import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { AUTHENTICATION_CONFIG, AuthenticationConfig, authenticationInterceptor, HEADER_MENU_PROVIDER, SIDE_NAV_PROVIDER } from '@maersk-global/angular-shared-library';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { IdTokenInterceptor } from './core/interceptors/IdToken-interceptor';
import { HeaderMenuService } from './core/services/header-menu.service';
import { SidenavMenuService } from './core/services/sidenav-menu.service';

export const appConfig: ApplicationConfig = {
  providers: [provideZoneChangeDetection({ eventCoalescing: true }),
  provideRouter(routes, withPreloading(PreloadAllModules)),
  { provide: SIDE_NAV_PROVIDER, useClass: SidenavMenuService },
  { provide: HEADER_MENU_PROVIDER, useClass: HeaderMenuService },
  {
    provide: AUTHENTICATION_CONFIG,
    useValue: {
      authority: environment.forgeRockAuthorityUrl,
      clientId: 'DryIot',
      postLoginRedirectUri: environment.postLoginRedirectUri,
      postLogoutRedirectUri: environment.postLoginRedirectUri,
      storage: { type: 'localStorage' },
      scopes: ['openid', 'email', 'profile', 'customer_code.any', 'roles'],
      inactivityLogoutSeconds: 1800,
      refreshTokenBeforeSeconds: 3600,
    } as AuthenticationConfig
  },
  provideHttpClient(withInterceptors([authenticationInterceptor, IdTokenInterceptor]))
  ]
};
